import { gql } from '@apollo/client';
import { createApolloQueriesString } from '../../helpers/apolloHelpers';
import { defaultResponse } from './defaultResponse';

const [
  parametersTypeString,
  parametersAssignString,
] = createApolloQueriesString([
  ['scrap_id', 'Int!'],
  ['tags', '[TagInput]'],
]);
export default function UPSERT_SCRAP_TAGS(responseString = '') {
  return gql`
    mutation UpsertScrapTags(${parametersTypeString}) {
      upsertScrapTags(${parametersAssignString}) {
        ${defaultResponse}
      }
    }
  `;
}
